
<script>
import { usePageUniverse } from "./mixin";
import Breadcrumbs from "@/components/molecules/breadcrumbs/mobile";
import Button from "@/components/atoms/button";
import PushProductsBlock from "@/components/organisms/push-products-block/mobile";
import ChildrenCategories from "@/components/organisms/product-list/product-list-header/children-categories";
import Container from "@/components/atoms/container";
import GridRow from "@/components/molecules/grid/grid-row";
import GridCol from "@/components/molecules/grid/grid-col";
import ContainerHeading from "@/containers/container-heading";
import Card from "@/components/molecules/card";
import HtmlParser from "@/components/organisms/cms-container/html-parser";
import { useNavigationPagesStructuredData } from "@/mixins/seo/navigationPagesStructuredData";
import SmartBanner from "@/components/molecules/smartbanner";
import { useContextStore } from "@/store/context";

export default {
  name: "DPNiv1",
  components: {
    Container,
    ContainerHeading,
    Button,
    Breadcrumbs,
    ChildrenCategories,
    PushProductsBlock,
    GridRow,
    Card,
    GridCol,
    HtmlParser,
    SmartBanner
  },
  setup() {
    const { isDisplayModeAppli } = useContextStore();
    const {
      showMoreDescription,
      imageCarotteFromageLait,
      imageAnanasPastequePain,
      imageVinFromagePoulet,
      imageAnanasPastequePlat,
      pushProductsTitle,
      fistPushZoneTitle,
      secondPushZoneTitle,
      UniversePageCodes,
      isNational,
      title,
      description,
      childrenCategories,
      pushZones,
      breadcrumb,
      breadcrumbs,
      getPushData,
      getPushProducts,
      truncatedText,
      showMoreText,
      mounted,
      onProductIntersect
    } = usePageUniverse();

    const { head } = useNavigationPagesStructuredData(breadcrumbs.value);
    useHead(head);

    onMounted(mounted);

    return {
      showMoreDescription,
      imageCarotteFromageLait,
      imageAnanasPastequePain,
      imageVinFromagePoulet,
      imageAnanasPastequePlat,
      pushProductsTitle,
      fistPushZoneTitle,
      secondPushZoneTitle,
      UniversePageCodes,
      isNational,
      title,
      description,
      childrenCategories,
      pushZones,
      breadcrumb,
      getPushData,
      getPushProducts,
      truncatedText,
      showMoreText,
      onProductIntersect,
      isDisplayModeAppli
    };
  }
};
</script>

<template>
  <div class="u-bgcolor-white">
    <ClientOnly v-if="!isDisplayModeAppli">
      <SmartBanner is-drive-app />
    </ClientOnly>
    <br>
    <Breadcrumbs
      v-if="breadcrumb.length > 0 "
      :breadcrumbs="breadcrumb"
    />
    <div class="u-pb-sm">
      <Container>
        <span
          v-if="title"
          class="u-font-24 u-font-secondary u-font-700 u-block"
        >
          {{ title }}
        </span>
        <div
          v-if="description"
          class="u-color-text-light u-font-14 u-mb-sm"
        >
          <HtmlParser
            context="page univers description"
            :content="truncatedText(description,showMoreDescription ? 0 : UniversePageCodes.Niv_1_2_Max_Description_length)"
          />
          <Button
            v-if="description.length > UniversePageCodes.Mobile_Niv_1_2_Max_Description_length && !showMoreDescription"
            link
            class="c-product-detail__description-more"
            @click="showMoreText"
          >
            lire la suite
          </Button>
        </div>
        <ChildrenCategories
          v-if="childrenCategories"
          :in-carousel="false"
          :children-categories="childrenCategories"
        />
      </Container>
    </div>

    <div
      v-if="getPushProducts(UniversePageCodes.Niv1_2_Produits).length > 0"
      class="u-bgcolor-bg u-pt-md u-pb-xlg"
    >
      <Card class="u-pt-sm u-pb-sm">
        <h2 class="u-font-secondary u-color-primary u-font-32 -font-700 u-text-center u-mt-lg u-mb-md u-pl-sm u-pr-sm">
          {{ pushProductsTitle }}
        </h2>
        <PushProductsBlock
          :label="trackingCodes.LABELGA.PageUnivers"
          :products="getPushProducts(UniversePageCodes.Niv1_2_Produits)"
          product-separator
          :is-national="isNational"
          @onProductIntersect="(i) =>onProductIntersect(i,UniversePageCodes.Niv1_2_Produits)"
        />
      </Card>
    </div>
    <template v-if="pushZones.length > 0">
      <ContainerHeading
        v-if="getPushData(UniversePageCodes.Mobile_Niv1_2_MEA,1).html_content || getPushData(UniversePageCodes.Mobile_Niv1_2_MEA,2).html_content || getPushData(UniversePageCodes.Mobile_Niv1_2_Banniere,1).html_content"
        class=""
        :img-path="imageCarotteFromageLait"
      >
        <h2 class="u-font-secondary u-color-primary u-font-32 -font-700 u-text-center u-mb-md">
          {{ fistPushZoneTitle }}
        </h2>

        <div class="u-ml-xxlg u-mr-xxlg u-ml-none@lg u-mr-none@lg">
          <GridRow class="u-mb-md">
            <GridCol
              v-if="getPushData(UniversePageCodes.Mobile_Niv1_2_MEA,1).html_content"
              class="u-mb-md@sm"
              sm="12"
            >
              <HtmlParser
                :context="`page univers MEA 1 :${fistPushZoneTitle}`"
                :promo-printing="true"
                :style="{width:'100%'}"
                :push-data="getPushData(UniversePageCodes.Mobile_Niv1_2_MEA,1)"
              />
            </GridCol>
            <GridCol
              v-if="getPushData(UniversePageCodes.Mobile_Niv1_2_MEA,2).html_content"
              sm="12"
            >
              <HtmlParser
                :context="`page univers MEA 2 :${fistPushZoneTitle}`"
                :promo-printing="true"
                :style="{width:'100%'}"
                :push-data="getPushData(UniversePageCodes.Mobile_Niv1_2_MEA,2)"
              />
            </GridCol>
          </GridRow>
          <GridRow v-if="getPushData(UniversePageCodes.Mobile_Niv1_2_Banniere,1).html_content">
            <GridCol>
              <HtmlParser
                :context="`page univers MEA 3 :${fistPushZoneTitle}`"
                :promo-printing="true"
                :style="{width:'100%'}"
                :push-data="getPushData(UniversePageCodes.Mobile_Niv1_2_Banniere,1)"
              />
            </GridCol>
          </GridRow>
        </div>
      </ContainerHeading>

      <ContainerHeading
        v-if="getPushData(UniversePageCodes.Mobile_Niv1_2_MEA_Producteur,1).html_content || getPushData(UniversePageCodes.Mobile_Niv_1_2_MEA_Recette,1).html_content"
        class=""
        :img-path="imageAnanasPastequePlat"
        dotted
      >
        <h2 class="u-font-secondary u-color-primary u-font-32 -font-700 u-text-center u-mb-md">
          {{ secondPushZoneTitle }}
        </h2>
        <GridRow>
          <GridCol
            v-if="getPushData(UniversePageCodes.Mobile_Niv1_2_MEA_Producteur,1).html_content"
            class="u-mb-md@sm"
            sm="12"
          >
            <HtmlParser
              :context="`page univers MEA 1:${secondPushZoneTitle}`"
              :style="{width:'100%'}"
              :promo-printing="true"
              :push-data="getPushData(UniversePageCodes.Mobile_Niv1_2_MEA_Producteur,1)"
            />
          </GridCol>
          <GridCol
            v-if="getPushData(UniversePageCodes.Mobile_Niv_1_2_MEA_Recette,1).html_content"
            sm="12"
          >
            <HtmlParser
              :context="`page univers MEA 2:${secondPushZoneTitle}`"
              :style="{width:'100%'}"
              :promo-printing="true"
              :push-data="getPushData(UniversePageCodes.Mobile_Niv_1_2_MEA_Recette,1)"
            />
          </GridCol>
        </GridRow>
      </ContainerHeading>
      <HtmlParser
        v-if="getPushData(universePageCodes.DP_Zone_Libre, 1).html_content"
        class="u-p-md"
        context="page univers zone libre"
        :content="getPushData(universePageCodes.DP_Zone_Libre, 1).html_content"
      />
    </template>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/globals/cms.scss";
</style>
